import { MdOutlineMap } from "react-icons/md";

const getDataFieldsAreaMapData = () => {
  return [
    {
      title: "Area",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      queryKey: "Filters",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
  ];
};

const getCustomizationAreaMapData = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Color Formatting",
      type: "CONDITIONAL_FORMATTING",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
  ];
};
const getAreamapChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/Mapchart.png",
    label: "AreaMap",
    value: "areamap",
    icon: <MdOutlineMap className="text-xl text-blue-950" />,
    fileName: "AreaMap.js",
  };
};

export {
  getCustomizationAreaMapData,
  getDataFieldsAreaMapData,
  getAreamapChartDetails,
};
